import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMobility } from "../api/mobility";
import { useSnackbar } from "notistack";

const useDeleteMobility = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationFn: deleteMobility,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Mobility"] });
      enqueueSnackbar(`기기 삭제 성공`, {
        variant: "success",
      });
    },
  });
  return mutation;
};

export default useDeleteMobility;
